type AuthLogoProps = {
  className?: string
}

export default function AuthLogo({ className = 'h-14 w-auto' }: AuthLogoProps) {
  return <img src="/assets/auth/logo-vividteal.svg" alt="Dashboard Insights" className={className} />
}
